import { UserModule } from '@/store/modules/user'

export const checkPermission = (value: string[]): boolean => {
  if (value && value instanceof Array && value.length > 0) {
    const roles = UserModule.roles
    const permissionRoles = value
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    return hasPermission
  } else {
    console.error('需要权限 例如 v-permission="[\'admin\',\'editor\']"')
    return false
  }
}

/** 管理员账号 admin */
export const isAdminAgent = (): boolean => {
  const agentId = String(UserModule.userInfo?.agentId || '').trim().toLowerCase()
  return agentId === 'admin'
}

/** observer / pingwei：仅协会管理下食安员相关菜单，且只读（列表/详情），不显示首页 dashboard */
const LIMITED_ASSOCIATION_AGENTS = new Set(['observer', 'pingwei'])

export const isObserverAgent = (): boolean => {
  const agentId = String(UserModule.userInfo?.agentId || '').trim().toLowerCase()
  return LIMITED_ASSOCIATION_AGENTS.has(agentId)
}

/** 受限账号登录后的默认首页（公司管理） */
export const getLimitedAgentHomePath = (): string => '/safetyOfficer/companyManage/index'

/** observer 可见的路由 name（含父级）；pingwei 共用 */
export const OBSERVER_ALLOWED_ROUTE_NAMES = new Set([
  'safety_officer_mgmt',
  'company_manage_list',
  'safety_officer_list',
  'exam_manage_list'
])
